//COMMON
import 'intersection-observer';
import './common';

//SASS - COMMON
import '../sass/main.scss';

import Swiper from 'swiper';
import {
    Autoplay
} from 'swiper/modules';

const swiperLogos = document.getElementById('swiperLogos');

if (swiperLogos) {

    const swiper = new Swiper(swiperLogos, {
        modules: [Autoplay],
        loop: true,
        speed: 5000,
        slidesPerView: 'auto',
        simulateTouch: false,
        autoplay: {
            enabled: true,
            delay: 0,
            pauseOnMouseEnter: true,
            disableOnInteraction: false,
        },
        spaceBetween: 30,
        breakpoints: {
            1920: {
                spaceBetween: 74
            }
        }
    })
}

const headerMain = document.getElementById('headerMain');

window.onscroll = function () {
    scrollHeaderHolder()
};

function scrollHeaderHolder() {
    if (window.pageYOffset > 0) {
        headerMain.classList.add("sticky");
    } else {
        headerMain.classList.remove("sticky");
    }
}